// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 48rem;
  background: var(--white);
  border-radius: 1.2rem;
  box-shadow: 0 1.6rem 3.2rem rgba(44, 39, 56, 0.04), 0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);
  display: block;
}

.header {
  height: 5.6rem;
  color: var(--orange);
  background: #fef7e8;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header .text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
}
.header .icon-cancel {
  font-size: 1.8rem;
  cursor: pointer;
}

.content {
  padding: 3.4rem 5rem 4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.content .title {
  font-size: 2.4rem;
  line-height: 2.9rem;
  font-weight: 500;
  color: var(--black);
}
.content .desc {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
  color: var(--black);
  text-align: center;
  margin-top: 2rem;
}
.content .actions {
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/popups/delete-popup/delete-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,0FACE;EAEF,cAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAIE;EACE,iBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAHF;AAKE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAME;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AALJ","sourcesContent":[":host {\n  width: 48rem;\n  background: var(--white);\n  border-radius: 1.2rem;\n  box-shadow:\n    0 1.6rem 3.2rem rgba(44, 39, 56, 0.04),\n    0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);\n  display: block;\n}\n\n.header {\n  height: 5.6rem;\n  color: var(--orange);\n  background: #fef7e8;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  & .text {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    letter-spacing: 0.005em;\n  }\n\n  & .icon-cancel {\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n}\n\n.content {\n  padding: 3.4rem 5rem 4rem;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & .title {\n    font-size: 2.4rem;\n    line-height: 2.9rem;\n    font-weight: 500;\n    color: var(--black);\n  }\n\n  & .desc {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    letter-spacing: 0.005em;\n    color: var(--black);\n    text-align: center;\n    margin-top: 2rem;\n  }\n\n  & .actions {\n    margin-top: 4rem;\n    display: flex;\n    justify-content: center;\n    gap: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
